import React from 'react';
import { Result, Button } from 'antd';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="error"
          title="出错了"
          subTitle={this.state.error?.message || '抱歉，页面出现了一些问题'}
          extra={
            <Button 
              type="primary" 
              onClick={() => window.location.href = '/'}
            >
              返回首页
            </Button>
          }
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 